import React from "react";
import Navbar from "@/components/Navbar";
import { Crosshair } from "@/components/Crosshair";
import ElfsightSocialFeed from "@/components/ElfsightSocialFeed";

export default function Social() {
  return (
    <div className="min-h-screen text-foreground">
      <Navbar />
      <div className="max-w-[1100px] mx-auto px-4 py-10">
        <div className="text-center animate-fade-up">
          <span className="font-mono text-[10px] uppercase tracking-[3.4px] text-volt">The Community</span>
          <h1 className="font-heading text-[42px] sm:text-[52px] font-black tracking-tighter leading-[0.98] mt-3">
            ON THE <span className="text-volt">FEED</span>
          </h1>
          <p className="mt-4 text-[15.5px] text-secondary-foreground font-body max-w-[46ch] mx-auto">
            What the OpticSwap community is running, trading, and talking about.
          </p>
        </div>
        <Crosshair className="my-8" />
        <ElfsightSocialFeed />
        <div className="h-10" />
      </div>
    </div>
  );
}
